import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: 100vh;

    display: flex;
    flex-direction: column;
    overflow-y: auto;

    background-color: ${theme.colors.white.Branco};

    @media (max-width: 768px) {
        height: auto;
        overflow-y: visible;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 0 20px;

    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ButtonsFinish = styled.div`
    width: 100%;
    max-width: 640px;
    padding-bottom: 40px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width: 479px) {
        gap: 24px;
        justify-content: center;

        > div {
            flex: 1;
            width: auto;
            max-width: none;
        }
    }
`;